import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';

export class ListFiltersBase extends BaseModel {
  @Expose()
  key!: string;

  @Expose()
  orderBy!: string;

  @Expose()
  orderType!: string;

  @Expose()
  limit!: number;

  @Expose()
  page!: number;
}
